module.exports = __webpack_public_path__ + "00da804c8db545d46c904fd7ca7abfb7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/btnControlScreenSharing.png
// module id = iY6Y
// module chunks = 27